import axios from 'axios';

// In production (EC2), REACT_APP_BACKEND_URL is NOT set.
// All /api/* calls go through nginx which proxies them to backend:8000.
// In local dev, set REACT_APP_BACKEND_URL=http://localhost:8000 in frontend/.env
// to hit the backend directly (since no nginx proxy runs locally).
const baseURL = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : `/api`;

/**
 * Clear auth state and redirect to /login (idempotent).
 * Auth lives in an httpOnly cookie the JS can't touch, so we fire a
 * best-effort POST /auth/logout to clear it server-side before redirecting.
 */
export function forceLogout() {
  api.post('/auth/logout').catch(() => {});
  if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
    window.location.href = '/login';
  }
}

const api = axios.create({
  baseURL,
  // Auth rides in the httpOnly access_token cookie — always send it.
  withCredentials: true,
  paramsSerializer: (params) => {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => sp.append(key, v));
      } else if (value !== undefined && value !== null) {
        sp.append(key, value);
      }
    });
    return sp.toString();
  },
});

// CSRF defense: the backend rejects cookie-authenticated state-changing
// requests that lack this header (it forces a CORS preflight cross-origin).
api.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // The token is httpOnly — we can't inspect expiry client-side anymore.
    // A 401 from the API is the single source of truth for "not logged in".
    if (error.response?.status === 401) {
      forceLogout();
    }
    return Promise.reject(error);
  }
);

export default api;
